<ng-container *ngIf="loaded(); else loading">
  <hyperkit-typography variant="h5" align="left" color="primary">
    {{ packageView.title() }}
  </hyperkit-typography>

  <hyperkit-tab-bar
    variant="secondary"
    mode="underline"
    (tabChange)="onSubtabChangeFromEvent($event)"
  >
    <!-- Overview tab -->
    <hyperkit-tab
      text="Overview"
      [selected]="subtab() === 'overview'"
      (click)="setSubtab('overview')"
    >
      <report-text-block
        title="Threat Description"
        [value]="packageView.description()"
      ></report-text-block>

      <report-text-block
        title="Mitigation Recommendations"
        [value]="packageView.mitigationRecommendations()"
      ></report-text-block>
    </hyperkit-tab>

    <!-- Queries & Notes tab -->
    <hyperkit-tab
      text="Queries & Notes"
      [selected]="subtab() === 'queryNotes'"
      (click)="setSubtab('queryNotes')"
    >
      <div class="query-container">
        <div class="env-header">
          <hyperkit-typography variant="h5" align="left" color="primary">
            Environments
          </hyperkit-typography>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            [text]="packageView.getNumEnvironments().toString()"
          ></hyperkit-tag>
        </div>
      </div>

      <!-- First-level accordion: one per environment -->
      <hyperkit-accordion
        *ngFor="let env of envs()"
        [title]="env.name"
        [expanded]="true"
      >
        <ng-template #headerTemplate>
          <div class="tool-header-template">
            <div class="tool-info">
              <!-- no logo for environments here -->
              <hyperkit-typography
                variant="emphasized"
                size="sm"
                color="primary"
              >
                {{ env.name }}
              </hyperkit-typography>
            </div>
            <hyperkit-tag
              mode="outline"
              [closable]="false"
              [text]="env.tools.length.toString()"
            ></hyperkit-tag>
          </div>
        </ng-template>

        <!-- Second-level accordion: one per tool -->
        <div>
          <hyperkit-accordion
            *ngFor="let tool of env.tools"
            [title]="tool.name"
            [expanded]="true"
          >
            <ng-template #headerTemplate>
              <div class="tool-header-template">
                <div class="tool-info">
                  <img width="20px" [src]="getToolIcon(tool.product)" />
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    color="primary"
                  >
                    {{ tool.name }}
                  </hyperkit-typography>
                </div>
                <hyperkit-tag
                  mode="outline"
                  [closable]="false"
                  [text]="(tool.generatedContent.Hunt?.length ?? 0).toString()"
                ></hyperkit-tag>
              </div>
            </ng-template>

            <!-- Content for each query under this tool -->
            <div
              class="content-container"
              *ngFor="let content of tool.generatedContent.Hunt"
            >
              <hyperkit-report-query-header
                [isPivot]="false"
                [category]="content.category"
                [numPivots]="content.pivots?.length || 0"
              ></hyperkit-report-query-header>
              <hyperkit-code-block [code]="content.query"></hyperkit-code-block>
              <report-text-block
                *ngIf="content.notes"
                title="Notes"
                variant="body"
                size="lg"
                [value]="content.notes"
              ></report-text-block>

              <!-- pivots -->
              <ng-container *ngFor="let pivot of content.pivots">
                <report-pivot-block
                  [pivot]="pivot"
                  [parentCategory]="content.category"
                ></report-pivot-block>
              </ng-container>
            </div>
          </hyperkit-accordion>
        </div>
      </hyperkit-accordion>
    </hyperkit-tab>
  </hyperkit-tab-bar>
</ng-container>
<ng-template #loading>
  <p>Loading…</p>
</ng-template>
